<template>
    <div>
        <form>
            <input ref="search1" type="search" class="searchSmall1" placeholder="zu 2.1 / zu 2" name="Suche" autocomplete="off" v-model="form.Suche" @input="onInput">
            <input ref="search2" type="search" class="searchSmall2" placeholder="zu 2.2 / zu 3" name="Suche2" autocomplete="off" v-model="form.Suche2" @input="onInput" @keyup.enter="onClick">
            <input type="button" @click="onClick" value="Suchen">
        </form>
        <div class="selectACar" v-if="multi">
            <div class="title">mehr als ein Auto verfügbar</div>
            <div v-for="car in cars">
                <div class="radio">
                    <label>
                        <input type="radio" name="carId[]" :value="car.id" v-model="selectedCarId" />
                        <span>{{car.brand}} {{car.model}} {{car.description}}</span>
                    </label>
                </div>
            </div>
            <button class="btn active" @click="selectMulti">auswählen</button>
            <button class="btn dark" @click="cancel">abbrechen</button>
        </div>
        <div class="selectACar" v-if="single">
            <div class="title">Sie haben ausgewählt</div>
            <div v-for="car in cars">
                <div class="selectedCar">{{car.brand}} {{car.model}} {{car.description}}</div>
            </div>
            <button class="btn active" @click="selectSingle">auswählen</button>
            <button class="btn dark" @click="cancel">abbrechen</button>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        s1: {
            type: [String],
            required: false,
            default: null
        },
        s2: {
            type: [String],
            required: false,
            default: null
        }
    },

    data() {
        return {
            selectedCarId: 0,
            multi: 0,
            single: 0,
            cars: [],
            form: new Form({
                Suche: null,
                Suche2: null
            })
        };
    },

    methods: {
        onInput() {
            //alert(event.keyCode);
            if(this.form.Suche.length > 4) {
                var str = this.form.Suche;
                this.form.Suche = str.substring(0,4);
                this.form.Suche2 = str.substring(4,7);
                this.$refs.search2.focus();
            }
            if(this.form.Suche.length == 4) {
                this.$refs.search2.focus();
            }
            if(this.form.Suche2.length > 3) {
                var str = this.form.Suche2;
                this.form.Suche2 = str.substring(0,3);
            }
        },

        onClick() {
            if(this.form.Suche != "" && this.form.Suche2 != "") {
                this.form.post('/search-kba').then(response => {
                    if(response.numCars == 0) {
                        this.form.Suche = response.Suche;
                        this.form.Suche2 = response.Suche2;
                        swal("", "Auto existiert nicht",  "error");
                    } else {
                        this.form.Suche = response.Suche;
                        this.form.Suche2 = response.Suche2;
                        this.cars = response.cars;
                        if(response.numCars == 1) {
                            this.single = 1;
                        } else {
                            this.multi = 1;
                        }
                    }
                });
            } else {
                swal("", "Auto existiert nicht",  "error");
            }
        },

        cancel() {
            this.single = 0;
            this.multi = 0;
        },

        selectSingle() {
            window.location = App.url+'/search/?searcType=car&Suche=' + this.form.Suche + '&Suche2=' + this.form.Suche2;
        },

        selectMulti() {
            window.location = App.url+'/search/?searcType=car&Suche=' + this.form.Suche + '&Suche2=' + this.form.Suche2 + '&carId=' + this.selectedCarId;
        }
    },

    created() {
        this.form.Suche = this.s1;
        this.form.Suche2 = this.s2;
    }

}
</script>
